import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { BookOpen, ArrowRight } from 'lucide-react';

const API = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/(api)?\/?$/, "")}/api`;

export default function RelatedBlogPosts({ city, facility_type, limit = 3 }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/blog/posts/related`, {
          params: { city, facility_type, limit },
        });
        if (!cancelled) setPosts(data || []);
      } catch (e) {
        // silent
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [city, facility_type, limit]);

  if (loading) return null;
  if (!posts.length) return null;

  return (
    <Card className="mt-6" data-testid="related-blog-posts">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <BookOpen className="w-5 h-5 text-emerald-600" />
          <h2 className="text-xl font-bold text-slate-900">İlgili Blog Yazıları</h2>
        </div>
        <div className="space-y-3">
          {posts.map((p) => (
            <Link
              key={p.post_id}
              to={`/blog/${p.slug}`}
              className="group flex gap-3 p-3 rounded-lg border border-slate-200 hover:border-emerald-300 hover:bg-emerald-50/50 transition-colors"
              data-testid={`facility-related-blog-${p.slug}`}
            >
              <div className="w-20 h-20 rounded-lg overflow-hidden bg-gradient-to-br from-emerald-100 to-emerald-200 flex-shrink-0">
                {p.cover_image ? (
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-emerald-700 font-bold opacity-30">TK</div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-slate-900 group-hover:text-emerald-700 line-clamp-2">{p.title}</h3>
                <p className="text-xs text-slate-500 mt-1 line-clamp-2">{p.excerpt}</p>
                <div className="flex items-center gap-1 text-xs text-emerald-600 mt-1 group-hover:gap-2 transition-all">
                  Oku <ArrowRight className="w-3 h-3" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
